export default {
  namespaced: true,
  state: {
    userInfo: {},
    token: '',
  },
  mutations: {
    setToken(state, token) {
      console.log(token,'ooo')
      state.token = token;
    },
    clearToken(state) {
      state.token = null;
    },
  }
}